import $ from 'jquery';

const get = $.get;
$.get = (url, data, options) => {
  return new Promise((resolve, reject) => {
    get({
      url,
      ...options,
      success: data => {
        resolve(data);
      },
      error: (xhr, status, err) => {
        resolve(new Error(err));
      },
    });
  });
};

const post = $.post;
$.post = (url, data, options) => {
  return new Promise((resolve, reject) => {
    post({
      url,
      contentType: 'application/json',
      data: JSON.stringify(data),
      dataType: 'json',
      ...options,
      success: data => {
        resolve(data);
      },
      error: (xhr, status, err) => {
        resolve(new Error(err));
      },
    });
  });
};
